import { AddressFormValues, Region } from './types'
import { isEmpty } from '../validateRequired'

export const isSameAddress = (
    source?: AddressFormValues,
    target?: AddressFormValues,
) => {
    if (!target || !source) {
        return false
    }

    // Helper to normalize string for comparison
    const normalize = (str: string | number | boolean | Region | undefined) =>
        str?.toString().toLowerCase().replace(/\s+/g, '') ?? ''

    const fieldsToCompare: Array<keyof AddressFormValues> = [
        'firstName',
        'lastName',
        'company',
        'street',
        'houseNumber',
        'suffix',
        'postalCode',
        'city',
        'country',
    ]

    return fieldsToCompare.every(
        (field) => normalize(source[field]) === normalize(target[field]),
    )
}

export const isAddressComplete = (address?: AddressFormValues): boolean => {
    if (!address) {
        return false
    }
    // suffix is optional
    const isComplete =
        !isEmpty(address.firstName) &&
        !isEmpty(address.lastName) &&
        !isEmpty(address.country) &&
        !isEmpty(address.street) &&
        !isEmpty(address.houseNumber) &&
        !isEmpty(address.postalCode) &&
        !isEmpty(address.city)

    return isComplete
}
